<template>
  <div class="text">
    <div class="inner">
      <!-- quote -->
      <template v-if="variant === 'quote'">
        <blockquote v-html="texxt"></blockquote>
      </template>
      <!-- default -->
      <template v-else>
        <div class="textbody" v-html="texxt"></div>
      </template>      
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionStoryText',
  props: ['variant', 'header', 'text'],
  data () {
    return {

    }
  },
  computed: {
    texxt () {
      switch (this.variant) {
        case 'quote':
          const lastP = this.text.lastIndexOf('</')
          const qtSrc = ' <span class="quote-source">' + this.header + '</span>'
          return lastP > -1 ? this.text.slice(0, lastP) + qtSrc + this.text.slice(lastP) : this.text + qtSrc
        default:
          return this.header ? '<h3>' + this.header + '</h3>' + this.text : this.text
      }
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';

.text{
  .inner{
    width:63.411132813%;
    margin:0 auto;
  }

  .textbody {
    @include h5();
  }

  blockquote{
    text-align: left;
    @include h4();
    @include century_mono();
    // citation
    .quote-source{
      text-transform: uppercase;
      font-weight: inherit;
      font-size: 0.9333333333em;
    }
  }

  @media (max-width:63em) {
    .inner{
      width:79.6875%; // match landscape image
      padding:0 $gutter;
    }
  }

  @include on_mobile() {
    margin:$collectionMobile-blockMargin-ns 0;
    .inner{
      width:auto;
      padding:0 $collectionMobile-textMargin-ew;
    }
    .textbody {
      @include h6();
    }
    blockquote {
      @include h5();
    }
  }

  @include narrow_screens () {
    blockquote {
      @include h6();
    }
  }
}
</style>



// WEBPACK FOOTER //
// Collection__Story__Text.vue?3644bc8f